import Axios from "axios";
import jwtDecode from "jwt-decode";
import moment from "moment";
import { webConfig, webApiGrantType } from "../config";

export default class AuthService {
  sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  // eslint-disable-next-line class-methods-use-this
  async login() {
    let param = "";
    let org = "";

    if (window.location.hostname.indexOf(".") !== -1) {
      org = this.recalculateOrg();
      param = `org=${org}`;
    }

    const qParams = [
      `response_type=code`,
      `redirect_uri=${window.location.origin + webConfig.REDIRECT_URL}`,
      `client_id=${webConfig.CLIENT_ID}`,
      `client_secret=${webConfig.CLIENT_SECRET}`,
      `scope=read`,
      webConfig.FRONTEND_URL !== window.location.origin ? param : "",
    ].join("&");

    let url = "";

    if (webConfig.FRONTEND_URL === window.location.origin) {
      url = `${webConfig.API_HOST + webConfig.AUTHORIZE_API}?${qParams}`;
    } else {
      url = `https://${org}-backend.dalipro.io/api/v1/${webConfig.AUTHORIZE_API}?${qParams}`;
    }

    window.location.assign(url);
  }

  async authCallBack(code) {
    const session = await this.getSession(code);
    if (session) {
      localStorage.setItem(
        webConfig.LOCAL_STORAGE_SESSION_KEY,
        JSON.stringify(session)
      );
    }
  }

  redirectTologin() {
    //redirect to login
    this.login();
  }

  thirdLevel() {
    return window.location.hostname.split(".")[0].toString();
  }

  recalculateOrg() {
     if (this.thirdLevel() === "flexcuiot") {
      return "remote-access";
     }

     return window.location.hostname.split(".")[0].toString();
  }

  // eslint-disable-next-line class-methods-use-this
  logout() {
    const org = this.recalculateOrg();
    const redirect = this.thirdLevel();
    const clientId = webConfig.CLIENT_ID;
    const clientSecret = webConfig.CLIENT_SECRET;

    localStorage.removeItem(webConfig.LOCAL_STORAGE_SESSION_KEY);

    if (webConfig.FRONTEND_URL === window.location.origin) {
      window.location.assign("../");
    } else {
      const url = `https://${org}-backend.dalipro.io/api/v1/logout?client_id=${clientId}&client_secret=${clientSecret}&org=${org}&redirect_uri=https%3A%2F%2F${redirect}.dalipro.io%2Flogin&response_type=code&scope=read`;
      window.location.assign(url);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isAuthenticated() {
    let authenticated = false;

    const storageSession = localStorage.getItem(
      webConfig.LOCAL_STORAGE_SESSION_KEY
    );

    if (storageSession) {
      const currentSession = JSON.parse(storageSession);

      if (currentSession && currentSession.expiresAt) {
        const expireTime = new Date(currentSession.expiresAt);
        const now = new Date();
        if (expireTime > now) {
          authenticated = true;
        }
      }
    }

    return authenticated;
  }

  // eslint-disable-next-line class-methods-use-this
  getCurrentSession() {
    const storageSession = localStorage.getItem(
      webConfig.LOCAL_STORAGE_SESSION_KEY
    );

    if (storageSession) {
      const currentSession = JSON.parse(storageSession);

      if (currentSession && currentSession.expiresAt) {
        const expireTime = new Date(currentSession.expiresAt);
        const now = new Date();
        if (expireTime > now) {
          return currentSession;
        }
      }
    }

    return null;
  }

  async refreshAuth() {
    const storageSession = localStorage.getItem(
      webConfig.LOCAL_STORAGE_SESSION_KEY
    );

    if (storageSession) {
      const currentSession = JSON.parse(storageSession);

      if (currentSession && currentSession.expiresAt) {
        const expireTime = new Date(currentSession.expiresAt);
        const now = new Date();
        if (expireTime <= now) {
          const newSession = await this.refreshToken(
            currentSession.refreshToken
          );
          localStorage.removeItem(webConfig.LOCAL_STORAGE_SESSION_KEY);
          localStorage.setItem(
            webConfig.LOCAL_STORAGE_SESSION_KEY,
            JSON.stringify(newSession)
          );
        }
      }
    }
  }

  getSession = async (authorizationCode) => {
    const params = new URLSearchParams();
    params.append("grant_type", webApiGrantType.authorization_code);
    params.append("code", authorizationCode);
    params.append(
      "redirect_uri",
      window.location.origin + webConfig.REDIRECT_URL
    );
    params.append("client_id", webConfig.CLIENT_ID);
    params.append("client_secret", webConfig.CLIENT_SECRET);
    params.append("scope", "read");

    let res;

    await Axios.post(webConfig.API_HOST + webConfig.TOKEN_API, params)
      .then((result) => {
        res = result.data;
      })
      .catch((error) => {
        console.log("error", error);
      });

    return this.makeSession(res);
  };

  makeSession = (result) => {
    try {
      const info = jwtDecode(result.access_token);

      return {
        provider: webConfig.LOCAL_STORAGE_SESSION_KEY,

        accessToken: result.access_token,
        refreshToken: result.refresh_token,
        expiresIn: result.expires_in,
        expiresAt: moment.utc().add(result.expires_in, "seconds").unix() * 1000, // do it in utc

        userId: info.user_id,
        organizationId: info.organization_id,
      };
    } catch (error) {
      return null;
    }
  };

  refreshToken = async (refreshToken) => {
    const params = new URLSearchParams();
    params.append("grant_type", webApiGrantType.refresh_token);
    params.append("refresh_token", refreshToken);
    params.append("client_id", webConfig.CLIENT_ID);
    params.append("client_secret", webConfig.CLIENT_SECRET);
    params.append("scope", "read");

    let res;
    await Axios.post(webConfig.API_HOST + webConfig.TOKEN_API, params).then(
      (result) => {
        res = result.data;
      }
    );

    return this.makeSession(res);
  };
}
